// extracted by mini-css-extract-plugin
module.exports = {"orange":"#FF6620","orangeLink":"OrangeLink_orangeLink__34ZRK"};